import clsx from "clsx";

import { sizeOptions } from "./page-size";

type PageResultsProps = {
  className?: string;
  currentPage?: number;
  totalCount?: number;
  pageSize?: number;
};
const PageResults = ({
  currentPage = 1,
  totalCount = 0,
  pageSize = Number(sizeOptions[0]),
  className,
}: PageResultsProps) => {
  if (!totalCount) {
    return null;
  }

  const pagesCount = Math.ceil(totalCount / pageSize);
  const pageStart = (Math.max(1, Math.min(currentPage || 1, pagesCount)) - 1) * pageSize + 1;
  const pageEnd = Math.min(pageStart + pageSize - 1, totalCount);
  return (
    <p className={clsx(className, "text-sm lg:text-base text-gray-400")}>
      Results {pageStart} - {pageEnd} of {totalCount}
    </p>
  );
};

export default PageResults;
